import OrderControlDetail from './OrderControlDetail';

export default OrderControlDetail;
